module.exports = __webpack_public_path__ + "images/minia240bcc3a973ae7c101088253fa7e458.png";